define(function (require) {

    var VisitInfoBase = require('web-agent-widgets/VisitInfoBase');
    var widgetConfig = require('web-agent-widgets/widgetConfig');
    var lpUtils = require('utils/lpUtils');


    var ConnectionsLogConsumerInfoWidget = VisitInfoBase.extend({
        ControllerName : "ConnectionsLogConsumerInfoWidget",
        applicationType : "ConsumerInfoWidget",

        LPViewMap : {
        },

        initialize : function (constructorData) {
        },

        events : function () {
        },

        render : function () {
        }
    });

    ConnectionsLogConsumerInfoWidget.prototype.widgetDataConfig = function(){
        return  widgetConfig.getInstance().getWidgetConfig("consumerInfo");
    };

    ConnectionsLogConsumerInfoWidget.prototype.getRootModelPath = function () {
        var path = VisitInfoBase.prototype.getRootModelPath.call(this);
        if(this.configuration.visitorInfoPath) {
            path += ("." + this.configuration.visitorInfoPath);
        }
        return path;
    };

    ConnectionsLogConsumerInfoWidget.prototype.preprocessingHandleVisit = function (data) {
        var visitorData = VisitInfoBase.prototype.preprocessingHandleVisit.call(this, data) || {};
        if (visitorData.startTime) {
            visitorData.startTime = lpUtils.formatDateAsString(visitorData.startTime);
        }
        return visitorData;
    };

    return ConnectionsLogConsumerInfoWidget;

});
